import React from "react";
import Productivity from "../assets/Productivity.jpg";

const About = () => {
  return (
    <div
      name="about"
      className="h-[900px] w-full bg-neutral-900 text-slate-300 md:h-[700px]"
    >
      <div className="flex h-full w-full flex-col items-center justify-center">
        <div className="grid w-full max-w-[1000px] grid-cols-2 gap-8 px-8">
          <div className="pb-8 sm:text-right">
            <p className="inline border-b-4 border-yellow-400 text-4xl font-semibold">
              About
            </p>
          </div>
        </div>
        <div className="grid w-full max-w-[1000px] gap-8 px-8 sm:grid-cols-2">
          <img src={Productivity} className="rounded-lg" />
          <div>
            <div className="text-3xl font-semibold">
              <p>Hi, I'm Michael! Nice to meet you.</p>
            </div>
            <div className="py-4 text-slate-400">
              <p>
                My goal is to develop web and mobile applications using React
                and Next.js. I strive to enhance user experiences through
                intuitive design and seamless functionality.
              </p>
              <p className="py-4">
                As a front-end developer, I'm actively seeking new opportunities
                to grow and contribute my expertise!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
